import { setPageContent } from "..";
import { locale } from "../locale";
import { Bulma } from "./bulma";
import { centeredBox } from "./components";

function notFoundPage() {
    setPageContent(
        centeredBox("small",
            Bulma.title(locale.string({
                enGB: "Page not found",
                deDE: "Seite nicht gefunden",
                frFR: "Page non trouvée",
                svSE: "Sidan hittades inte"
            })),
            Bulma.buttons(
                Bulma.button(
                    {
                        onClick: () => window.history.back(),
                        styles: ["is-primary"],
                    },
                    locale.string({
                        enGB: "Return to previous page",
                        deDE: "Zurück zur vorherigen Seite",
                        frFR: "Retourner à la page précédente",
                        svSE: "Återvänd till föregående sida",
                    })
                ),
            ),
        ),
    )
}

export {
    notFoundPage
};
